export default __webpack_public_path__ + "static/superbetter-design-tab-732f2c0c6c93a7b5026994f170f05b26.webp";